import type { ComponentProps } from 'react';

import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cn } from '@repo/lib/cn';

function Separator(separatorProps: ComponentProps<typeof SeparatorPrimitive.Root>) {
  const { className, orientation = 'horizontal', decorative = true, ...props } = separatorProps;

  return (
    <SeparatorPrimitive.Root
      data-slot="separator-root"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        'bg-border-primary shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        className
      )}
      {...props}
    />
  );
}

export { Separator };
